// extracted by css-extract-rspack-plugin
export default {"editIcon":"ProductVariantPriceCell_editIcon__0Dekq","editIconHover":"ProductVariantPriceCell_editIconHover__2IcsK","iconRightStack":"ProductVariantPriceCell_iconRightStack__3mLrm"};